export default __webpack_public_path__ + "static/media/hangot-screenshot-06.17ec88da.png";